import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import 'rxjs/add/operator/map'

import { PagerService } from '../pager.service'

@Component({
  selector: 'app-all-news',
  templateUrl: './all-news.component.html',
  styleUrls: ['./all-news.component.scss']
})
export class AllNewsComponent implements OnInit {
  pageOfItems: Array<any>;

  cookieData: any
  isCrisis = false

  // array of all items to be paged
  private allItems: any[];

  // pager object
  pager: any = {};

  // paged items
  pagedItems: any[];

  @ViewChildren('allNews') news: QueryList<any>;

  constructor(
    private apiService: ApiService,
    private util: UtilService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private pagerService: PagerService
  ) { }

  async ngOnInit() {
    this.util.ShowWaiting(true)
    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    if(this.cookieData == null){
      this.cookieData = {}
    }

    let config: any = await this.apiService.get("master", "configuration")
    let crisisConfig: any = config.filter((c: any) => {
      return c.dpa_name == "CRISIS FLAG"
    })
    if (crisisConfig != null && crisisConfig.length > 0 && crisisConfig[0].dpa_crisisflag != null && crisisConfig[0].dpa_crisisflag == true) {
      this.cookieData.isCrisis = true
      this.isCrisis = true
      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
    }
    else {
      this.cookieData.isCrisis = false
      this.isCrisis = false
      localStorage.setItem("dpa_portal", JSON.stringify(this.cookieData))
    }

    await this.getAllNews()
  }

  async getAllNews() {
    let para = "dpa_publishstatus=true&dpa_isdisplayoncustomerportal=true&dpa_iscrisis=" + this.isCrisis.toString()
    let newsList: any = await this.apiService.get("crmservice", "news", para)
    
    this.util.ShowWaiting(true)
    if(newsList != null && newsList.length > 0){
      newsList.forEach((n: any) => {
        if (n.attachfilelist != null && n.attachfilelist.length > 0) {
          n.imgSrc = this.sanitizer.bypassSecurityTrustUrl('data:' + n.attachfilelist[0].mimetype + ';base64, ' + n.attachfilelist[0].documentbody);
        }
      });
      this.allItems = newsList
    }
    else{
      this.allItems = []
    }
    this.setPage(1);
  }

  setPage(page: number) {
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page);

    // get current page of items
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  ngAfterViewInit() {
    this.news.changes.subscribe(t => {
      this.ngForRendred();
    })
  }

  ngForRendred() {
    this.util.ShowWaiting(false)
  }
}



// WEBPACK FOOTER //
// ./src/app/all-news/all-news.component.ts